import React, {useEffect, useState} from "react";

import {Auth} from "@digatex/digatex-ui-lib";
import {Card, Col, Image, Row, Spin, Tooltip, Typography} from "antd";

import {openLinkInNewTab} from "../helpers";
import {OWNER, properties} from "../properties";

const hasAccessToModule = (moduleName, permissions) => {
	const moduleToApiMap = {
		Workbench: "workbench-api",
		Equipment: "eh-api",
		Knowledge: "kh-api",
		Engineering: "data-mapper-api",
		Inventory: "inventory-api",
		"Advanced Reporting": "reporting-api",
	};

	const apiKey = moduleToApiMap[moduleName];
	return permissions[apiKey] && permissions[apiKey].roles.length > 0;
};

function LandingCard({product, url, height, disabled}) {
	const cardStyle = {
		borderColor: properties.kbrColors.pantone301Blue,
		height,
		borderRadius: 15,
		cursor: disabled ? "default" : "pointer",
		opacity: disabled ? 0.6 : 1,
		pointerEvents: disabled ? "none" : "auto",
	};

	return (
		<Card
			style={cardStyle}
			onClick={() => !disabled && url && openLinkInNewTab(url)}
			className={`landing-links flex-center-vertically ${disabled && "disabled-product"}`}>
			<div style={{textAlign: "center"}}>
				{OWNER === "digatex" && <div>{product.icon && <Image src={product.icon} style={{height: 60}} />}</div>}
				<Typography.Title level={4} style={{color: properties.kbrColors.pantone301Blue, fontSize: 24}}>
					<Tooltip title={url}>
						<span>{product.name}</span>
					</Tooltip>
				</Typography.Title>
				<ul style={{textAlign: "left"}}>
					{product.include && product.include.map((f, index) => <li key={index}>{f}</li>)}
				</ul>
			</div>
		</Card>
	);
}

export function LandingPage() {
	const [permissions, setPermissions] = useState({});
	const [loading, setLoading] = useState(true);
	const tokenParsed = Auth.tokenParsed();

	useEffect(() => {
		document.title = "Landing Page";
		if (tokenParsed) {
			setPermissions(tokenParsed.resource_access || {});
			setLoading(false);
		} else {
			setLoading(false);
			console.warn("Token is invalid or missing:", tokenParsed);
		}
	}, [tokenParsed]);

	if (loading) {
		return <Spin size="large" />;
	}

	const modules = ["ihLink", "dmLink", "analyticsLink", "assetHubLink", "khLink", "reportingLink"];
	const names = [
		{
			name: "Inventory",
			icon: "/images/ih_icon.png",
			include: [
				"Consolidate Material Master data",
				"Display transactions, BOM's etc associated with each MM item",
			],
		},
		{
			name: "Engineering",
			icon: "/images/engh_icon.png",
			include: ["Class Library", "Data Mapper", "Source Matrix", "Registers"],
		},
		{
			name: "Workbench",
			include: [
				"Display potential savings option",
				" MIN MAX scenarios",
				"Insurance Spares",
				"Calculation settings",
			],
		},
		{name: "Equipment", include: ["Configure: FLOC's, BOM's, Materials, Construction Types, PM Plans etc"]},
		{
			name: "Knowledge",
			icon: "/images/kh_icon.png",
			include: [
				"Provide intelligently searchable documents",
				"Create equipment hierarchies",
				"Mark up drawings e.g. corrosion loops, SIL Levels, criticality",
			],
		},
		{name: "Advanced Reporting", include: ["Reporting across datasets", "Visual iteractive heat map generation"]},
	];

	const columns_span = 6;
	const span_1 = Math.floor((24 - columns_span * 2) / 2);
	const span_2 = Math.floor((24 - columns_span * 3) / 2);

	return (
		<div style={{margin: "auto"}}>
			<Row style={{margin: "auto"}}>
				<Col span={span_1} />
				<Col xxl={columns_span} xl={columns_span} lg={columns_span} md={columns_span} sm={columns_span * 2}>
					<LandingCard
						height={215}
						product={names[2]}
						url={properties[modules[2]]}
						disabled={!hasAccessToModule(names[2].name, permissions)}
					/>
				</Col>
				<Col xxl={columns_span} xl={columns_span} lg={columns_span} md={columns_span} sm={columns_span * 2}>
					<LandingCard
						height={215}
						product={names[3]}
						url={properties[modules[3]]}
						disabled={!hasAccessToModule(names[3].name, permissions)}
					/>
				</Col>
			</Row>
			<Row style={{margin: "auto"}}>
				<Col span={span_2} />
				<Col xxl={columns_span} xl={columns_span} lg={columns_span} md={columns_span} sm={columns_span * 2}>
					<LandingCard
						height={285}
						product={names[4]}
						url={properties[modules[4]]}
						disabled={!hasAccessToModule(names[4].name, permissions)}
					/>
				</Col>
				<Col xxl={columns_span} xl={columns_span} lg={columns_span} md={columns_span} sm={columns_span * 2}>
					<LandingCard
						height={285}
						product={names[1]}
						url={properties[modules[1]]}
						disabled={!hasAccessToModule(names[1].name, permissions)}
					/>
				</Col>
				<Col xxl={columns_span} xl={columns_span} lg={columns_span} md={columns_span} sm={columns_span * 2}>
					<LandingCard
						height={285}
						product={names[0]}
						url={properties[modules[0]]}
						disabled={!hasAccessToModule(names[0].name, permissions)}
					/>
				</Col>
			</Row>
			<Row style={{margin: "auto"}}>
				<Col span={8} />
				<Col xxl={8} xl={8} lg={8} md={8} sm={8 * 2}>
					<LandingCard
						height={200}
						product={names[5]}
						url={properties[modules[5]]}
						disabled={!hasAccessToModule(names[5].name, permissions)}
					/>
				</Col>
			</Row>
		</div>
	);
}
